const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/discover/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickNumber } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { requireGuestOrMember } from "@/routes/_app/guards";
import { getRootLoaderData } from "@/types/intl";
import { isDiscoveryDecade } from "@garimpa/lib/discoveryDecades";
interface DiscoverSearch {
  page?: number;
  temperature?: number;
  decade?: DiscoveryDecade;
}
export const Route = createFileRoute("/_app/discover/")({
  validateSearch: (raw: Record<string, unknown>): DiscoverSearch => {
    const page = pickNumber(raw.page);
    const temperature = pickNumber(raw.temperature);
    const decade = pickNumber(raw.decade);
    return {
      page: page && Number.isInteger(page) && page > 1 && page <= 26 ? page : undefined,
      temperature: temperature != null && temperature >= 0 && temperature <= 1 ? temperature : undefined,
      decade: decade != null && isDiscoveryDecade(decade) ? decade : undefined
    };
  },
  beforeLoad: ({
    context: {
      queryClient
    }
  }) => requireGuestOrMember({
    queryClient
  }),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "discover"
    });
    return {
      meta: buildPrivatePageMetaTags(t("title"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});